import { useEffect, useState } from "react";
import { navItems } from "@/mocks/jiuse";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="relative z-50">
      {/* 报头细条：日期与副标 */}
      <div className="border-b border-background-200/80 bg-background-50">
        <div className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-2 text-[12px] tracking-wide text-foreground-600 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-flashlight-line text-primary-600" aria-hidden="true" />
            <span>原图级画面 · 持续整理中</span>
          </p>
          <p className="whitespace-nowrap text-foreground-500">二〇二六年九月六日 · 星期日</p>
        </div>
      </div>

      {/* 主报头：品牌突出 */}
      <div className={scrolled ? "border-b border-background-200/80 bg-background-50/90 backdrop-blur" : "border-b border-background-200/80 bg-background-50"}>
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
          <div className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-primary-600 text-lg text-background-50">
              <i className="ri-newspaper-line" aria-hidden="true" />
            </span>
            <div className="leading-tight">
              <h1 className="font-display text-[26px] font-bold tracking-tight md:text-3xl">
                九色黑料<span className="text-primary-600">网</span>
              </h1>
              <p className="text-[11px] tracking-[0.2em] text-foreground-500">图片 · 视频 · 截图原图专区</p>
            </div>
          </div>

          {/* 桌面导航 */}
          <nav aria-label="分区导航" className="hidden items-center gap-1 lg:flex">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-primary-700"
              >
                {it.label}
              </a>
            ))}
          </nav>

          {/* 移动端菜单按钮 */}
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="grid h-10 w-10 place-items-center rounded-full text-xl text-foreground-800 transition hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line" : "ri-menu-4-line"} aria-hidden="true" />
          </button>
        </div>

        {open && (
          <nav aria-label="移动端分区导航" className="border-t border-background-200/80 px-4 py-3 lg:hidden">
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((it) => (
                <a
                  key={it.href}
                  href={it.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-2 rounded-lg bg-background-100 px-3 py-2 text-sm font-medium text-foreground-800"
                >
                  <i className="ri-corner-down-right-line text-primary-600" aria-hidden="true" />
                  {it.label}
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}